/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import applySelection from './helpers/applySelection';

export const selectProductItem = createAction('products/selectProductItem');

export const reducer = (builder) => {
  builder
    .addCase(selectProductItem, (state, { payload }) => {
      state.ui.selection = applySelection(state.ui.selection, state.search.items, payload);
    });
};
